/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap";
import {mediaQuery} from "../utils/utils";
import {homeShopSwiper} from "../modules/swiper";
// import {ScrollSmoother} from "gsap/ScrollSmoother";

/* =============================================================
 * function
 * ========================================================== */


export default function exe() {

  homeShopSwiper();
  conceptGradient();

  /*
  const namespace = data.current.namespace; // barbajsからdataを取得

  // 遷移元ページが存在しない場合（TOPページにランディングした場合）のみ実行
  if (namespace === '') {
    console.log('top landing');
  }
  */
}


/* ********************************************
 * function
 * ****************************************** */
function conceptGradient() {
  const trigger = document.querySelector('.js-concept_trigger');
  const filter = document.querySelectorAll('.js-concept_filter');
  let end = 'bottom bottom';
  if (mediaQuery() === 'sp') {
    end = 'top bottom+200';
  }

  // Follow Sidebar
  if (trigger && filter) {

    gsap.from(filter, {
      // borderRadius: '0px 0px 0px 0px',
      autoAlpha: 0,
      scrollTrigger: {
        trigger: trigger,
        start: 'top bottom',
        endTrigger: trigger,
        end: end,
        // pin: true,
        // pinSpacing: false,
        scrub: true,
        invalidateOnRefresh: true, // update on resize
      },
    });

  }
}
